/**
 * Any Dealer-specific javascript can be added here.
 *
 * The OEM theme's JS is all bundled by mix, but if you need to include a
 * import a specific file, '@oem-theme' is an alias to the OEM theme's
 * 'assets/js' folder, and can be referenced like so:
 * import { convertStrToMilitaryTime } from '@oem-theme/utilities.js';
 *
 * For convenience, '@dealer' is an alias to this theme's 'assets/js' folder.
 */

import $ from 'jquery';

// after slider init
$('.home-promos-slider img').on('load', function () {
  $('.home-promos-slider').slick('setPosition');
});
// also on window load
$(window).on('load', () => $('.home-promos-slider').slick('setPosition'));

// add .inventory-page to body.page-template-vehicle-landing for needed styles
document.addEventListener('DOMContentLoaded', () => {
  const body = document.body;

  if (body.classList.contains('page-template-vehicle-landing')) {
    body.classList.add('inventory-page');
  }
});

document.addEventListener('DOMContentLoaded', function () {
  $('.callout-about')
    .find('.callout-about__links')
    .find('.link')
    .each(function () {
      $(this).removeClass('stacked');
    });

  $('.bnpcard.home-bnp-card')
    .find('.bnpcard__spacer + .button')
    .removeClass('btn-brand-1')
    .addClass('btn-brand-3');

  const params = new URLSearchParams(window.location.search);
  const modalId = params.get('openModal');

  if (modalId) {
    MicroModal.show(modalId);

    if (window.history.replaceState) {
      const url = new URL(window.location);
      url.searchParams.delete('openModal');
      window.history.replaceState({}, document.title, url.pathname + url.hash);
    }
  }
});
